import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './utils/gradeDiagnostics'; // Load diagnostics tool

// Global error handler to catch Firestore internal assertion errors
window.addEventListener('error', (event) => {
  // Silently handle Firestore internal assertion errors - they're often non-fatal
  if (event.error && event.error.message && event.error.message.includes('INTERNAL ASSERTION')) {
    console.warn('Firestore internal assertion (non-fatal, caught globally):', event.error.message);
    event.preventDefault(); // Prevent the error from being logged as unhandled
    return true;
  }
});

// Also catch unhandled promise rejections
window.addEventListener('unhandledrejection', (event) => {
  // Silently handle Firestore internal assertion errors in promises
  if (event.reason && event.reason.message && event.reason.message.includes('INTERNAL ASSERTION')) {
    console.warn('Firestore internal assertion in promise (non-fatal, caught globally):', event.reason.message);
    event.preventDefault(); // Prevent the error from being logged as unhandled
  }
});

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <App />
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
